import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

/** TableHeadCell are the cells that contain the data in the table header*/
const TableHeadCell = props => {
  const { className, children, ...other } = props;

  return (
    <th
      scope="col"
      className={clsx("em-c-table__header-cell", className)}
      {...other}
    >
      {children}
    </th>
  );
};

TableHeadCell.propTypes = {
  /** children are the contents of the TableHeadCell */
  children: PropTypes.node,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string
};

TableHeadCell.defaultProps = {
  children: null,
  className: ""
};

export default TableHeadCell;
